import { ScoreCardInput } from '../../../../lib/types/models/score-card/score-card-input'

export enum ScoreCardEnteredFieldsStatusEnum {
  NOT_ENTERED = 'NOT_ENTERED',
  ENTERED_FIRST_CONTACT = 'ENTERED_FIRST_CONTACT',
  ENTERED_SECOND_CONTACT = 'ENTERED_SECOND_CONTACT',
  ENTERED_THIRD_CONTACT = 'ENTERED_THIRD_CONTACT',
  ENTERED_SCHEDULED_INTERVIEW = 'ENTERED_SCHEDULED_INTERVIEW',
  ENTERED_EVALUATIONS = 'ENTERED_EVALUATIONS',
  ENTERED_INTERVIEW_DETAILS = 'ENTERED_INTERVIEW_DETAILS'
}

export const getScoreCardEnteredFieldsStatus = (
  data: ScoreCardInput
): ScoreCardEnteredFieldsStatusEnum => {
  const {
    // candidate details
    firstContactDate,
    secondContactDate,
    thirdContactDate,

    // interview details
    interviewStartDate,
    interviewStartHour,
    interviewStartMinute,

    // evaluations
    presentation,
    ponctuality,
    motivation,
    senseOfResponsability,
    relevanceOfAnswer,
    elocution,
    reactivity,
    globalAppreciation,
    levelOfLanguages,
    hobbies,
    doesHaveAPeculiarTalent,
    doesKnowLECPerson,
    comments,
    isApplicantRecommendedForHire,

    // interview transcript
    transcript,
    video
  } = data
  let status: ScoreCardEnteredFieldsStatusEnum = ScoreCardEnteredFieldsStatusEnum.NOT_ENTERED

  // check if the contact dates are entered
  if (!!firstContactDate) status = ScoreCardEnteredFieldsStatusEnum.ENTERED_FIRST_CONTACT
  if (!!secondContactDate) status = ScoreCardEnteredFieldsStatusEnum.ENTERED_SECOND_CONTACT
  if (!!thirdContactDate) status = ScoreCardEnteredFieldsStatusEnum.ENTERED_THIRD_CONTACT

  // check if the interview scheduled time (date, hour and time) is entered
  const didEnterScheduleInterview = Boolean(
    interviewStartDate &&
    typeof interviewStartHour === 'number' &&
    typeof interviewStartMinute === 'number' &&
    interviewStartHour >= 0 &&
    interviewStartMinute >= 0
  )
  if (didEnterScheduleInterview)
    status = ScoreCardEnteredFieldsStatusEnum.ENTERED_SCHEDULED_INTERVIEW

  // check if the evaluations are entered
  const didEnterEvaluations = Boolean(
    presentation ||
    ponctuality ||
    motivation ||
    senseOfResponsability ||
    relevanceOfAnswer ||
    elocution ||
    reactivity ||
    globalAppreciation ||
    (levelOfLanguages.length > 0 && levelOfLanguages.some((language) => language.level)) ||
    hobbies?.length > 0 ||
    doesHaveAPeculiarTalent ||
    doesKnowLECPerson ||
    comments ||
    // isApplicantRecommendedForHire is a boolean, so we need to check if it is defined and not null
    (isApplicantRecommendedForHire !== undefined && isApplicantRecommendedForHire !== null)
  )
  if (didEnterEvaluations) status = ScoreCardEnteredFieldsStatusEnum.ENTERED_EVALUATIONS

  // check if the interview transcript or video are entered
  const didEnterInterviewDetails = Boolean(transcript?.path || video?.path)
  if (didEnterInterviewDetails) status = ScoreCardEnteredFieldsStatusEnum.ENTERED_INTERVIEW_DETAILS

  return status
}
